/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Commons_Nav_OverviewInputs */

const de_commons_nav_overview = /** @type {(inputs: Commons_Nav_OverviewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Übersicht`)
};

/** @type {(inputs: Commons_Nav_OverviewInputs) => LocalizedString} */
const en_commons_nav_overview = de_commons_nav_overview;

/**

* @param {Commons_Nav_OverviewInputs} inputs
* @param {{ locale?: "de" | "en" }} options
* @returns {LocalizedString}
*/
export const commons_nav_overview = /** @type {((inputs?: Commons_Nav_OverviewInputs, options?: { locale?: "de" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Commons_Nav_OverviewInputs, { locale?: "de" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_commons_nav_overview(inputs)
	return en_commons_nav_overview(inputs)
});